import React, { Component } from 'react'
import Cleave from 'cleave.js/dist/cleave-react'
import ValidationUtil from '../../common/utils/ValidationUtil'
import { PopupMessage } from '../components'
import { GeneralFunctions } from '../helper'
import styled from 'styled-components'

const InputWrapper = styled.div`
  display: inline-block;
  input {
    background-color: #fff;
    border: 1px solid #ccc;
    display: inline-block;
    height: 20px;
    padding: 4px 6px;
    margin-bottom: 10px;
    font-size: 13px;
    line-height: 20px;
    color: #555;
    border-radius: 4px;
    vertical-align: middle;
  }
  input[disabled] {
    background: #f4f4f4 !important;
  }
`
class DefaultInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      value: props.value || '',
      showHelpPopup: false,
      isClicked: false,
      errorMessage: props.errorMessage || '',
      showHelpText: false,
      showLinkHelpText: true,
      backgroundMissingValue:
        props.backgroundMissingValue && [null, ''].includes(props.value),
      allowHTMLInErrorMessage: props.allowHTMLInErrorMessage || false
    }
  }
  componentDidMount() {
    if (this.props.value === 0) {
      this.state.value = 0
    }
  }
  _parseInt = val => {
    return parseInt(val, 10)
  };
  handleClick = e => {
    const { onClick, helpImageClass, helpText } = this.props
    if (onClick) {
      onClick(e)
    }
    this.setState({ showHelpText: helpText, showLinkHelpText: helpImageClass })
  };
  toggleDialog = () => {
    const { showHelpPopup } = this.state
    this.setState({ showHelpPopup: !showHelpPopup })
  };
  onKeyPress = e => {
    const { onKeyPress } = this.props
    if (e.which === 13) {
      e.preventDefault()
      e.target.blur()
    }
    if (onKeyPress) {
      onKeyPress(e)
    }
  };
  validateInput = e => {
    const {
      optional_input,
      validationType,
      onBlur,
      helpImageClass,
      forceSave,
    } = this.props
    const { value } = this.state

    let valid, messageError
    if (validationType) {
      const isValid = ValidationUtil.validate(
        value,
        validationType
      )
      messageError = !isValid && 'Please enter a valid value'
      valid = isValid
    }
    if (forceSave || optional_input) {
      valid = true
    }
    onBlur(e, valid, messageError, forceSave)
    // P&L Helptext
    if (helpImageClass) {
      const hasValue = value === ''

      this.setState({ showHelpText: hasValue, showLinkHelpText: hasValue })
    }
  };
  componentWillReceiveProps(nextProps) {
    let { backgroundMissingValue } = this.props
    const { value } = nextProps
    backgroundMissingValue = backgroundMissingValue && [null, ''].includes(value)

    this.setState({ backgroundMissingValue })
  }
  allowHTMLInErrorMessage = () => {
    const { errorMessage } = this.props
    const { allowHTMLInErrorMessage } = this.state

    if (allowHTMLInErrorMessage) {
      return (
        <span
          className="text-color-red"
          dangerouslySetInnerHTML={{ __html: errorMessage }}
        />
      )
    }
    return <span className="text-color-red">{errorMessage}</span>
  };
  getErrorClassName = () => {
    const { error, helpText, helpImageClass, disabled } = this.props
    const { isClicked } = this.state

    let errorClassName = 'focus-message text-color-light-gray'
    if (Boolean(disabled) && helpText) {
      errorClassName = 'help-text-message text-color-light-gray'
    } else if (error && helpImageClass || isClicked) {
      errorClassName = 'focus-message show-me-inline text-color-red'
    } else if (error && helpText) {
      errorClassName = 'focus-message show-me-inline-block text-color-red'
    } else if (error) {
      errorClassName = 'text-color-red error-font p-no-margin'
    }

    return errorClassName
  };
  renderHelperError = () => {
    const { errorAbsolute, error, helpText } = this.props
    const { showHelpText } = this.state

    return (
      <div
        className={`keep-text-left ${this.getErrorClassName()} ${
          errorAbsolute ? 'absolute' : ''
        }`}
      >
        {error
          ? this.allowHTMLInErrorMessage()
          : showHelpText && (
            <span className="show-me text-color-light-gray">
              {helpText}
            </span>
          )}
      </div>
    )
  };
  changeInputText = (value, id) => {
    const { cleaveCurrency } = this.props
  
    let finalValue = value
    if (cleaveCurrency) {
      finalValue = value.replace(/[^0-9.]+/g, '')
    } 
    if (['email'].includes(id)) {
      finalValue = GeneralFunctions.trimString(value)
    }

    this.setState({ value: finalValue })
  };
  onChange = e => {
    const { value, id } = e.target

    this.changeInputText(value, id)
  };
  renderInput = () => {
    const {
      disabled,
      type,
      autocomplete: autoComplete,
      name,
      placeholder,
      id,
      onKeyUp,
      error,
      turnOnWarning,
      cleave,
      dataModel,
      dataModelId,
      dataIndex,
      format,
      dataAttribute,
      bigStyle,
      widthSize
    } = this.props
    const {
      backgroundMissingValue,
      value
    } = this.state
    const warnings = error && ' error' || turnOnWarning && 'warning'
    const className = `${bigStyle ? 'big-style' : ''}${backgroundMissingValue ? ' background-light-orange' : ''} ${warnings || ''}`
    let style = {}
    if (widthSize) {
      style.width = widthSize
    }

    const commonProps = {
      disabled,
      type,
      autoComplete,
      name,
      placeholder,
      id,
      value,
      onKeyUp,
      onKeyPress: this.onKeyPress,
      onBlur: this.validateInput,
      onClick: this.handleClick,
      onChange: this.onChange,
      'data-model': dataModel,
      'data-model-id': dataModelId,
      'data-index': dataIndex,
      'data-format': format,
      'data-attribute': dataAttribute || id,
      className,
      style
    }

    return (
      cleave ? (
        <Cleave {...commonProps} options={cleave} />
      ) : (
        <input {...commonProps} />
      )
    )
  }
  render() {
    const {
      helpImageClass,
      label,
      id,
      turnOnWarning,
      helpText
    } = this.props
    const {
      showHelpPopup
    } = this.state

    return (
      <div
        className={`add-space-bottom ${
          helpText ? 'input-focus-message' : ''
        }`}
      >
        {showHelpPopup && (
          <PopupMessage showCloseButton onClose={this.toggleDialog}>
            <div className={helpImageClass} />
          </PopupMessage>
        )}
        {label && (
          <label
            className={turnOnWarning && 'text-color-yellow'}
            htmlFor={id}
            dangerouslySetInnerHTML={{ __html: label }}
          />
        )}
        <InputWrapper>
          {this.renderInput()}
        </InputWrapper>
        {this.renderHelperError()}
      </div>
    )
  }
}


export default DefaultInput